var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 5.6C17.2598 5.6 18.2 4.3464 18.2 2.8C18.2 1.2536 17.2598 0 16.1 0C14.9402 0 14 1.2536 14 2.8C14 4.3464 14.9402 5.6 16.1 5.6Z",
    fill: "#e0e0e0cc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3156 7C12.4964 6.45243 12.6003 5.86444 12.6003 5.24993C12.6003 2.35066 10.4061 0 7.70029 0C4.99451 0 2.80029 2.35066 2.80029 5.24993C2.80029 5.86418 2.90393 6.45217 3.08498 7H12.3156Z",
    fill: "#e0e0e0cc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.40004V11.1L8.74991 15.6001V21L12.2501 19.2V15.6001L21 11.1V8.40004H0Z",
    fill: "#e0e0e0cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.489c899aab1c46e2e21f261ee8555d92.svg";
export { ForwardRef as ReactComponent };